import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Ticker } from '../components/Ticker';
import { Mission } from '../components/Mission';
import { UseCases } from '../components/UseCases';
import { Materials } from '../components/Materials';
import { Product } from '../components/Product';
import { WhatsInBox } from '../components/WhatsInBox';
import { SocialProof } from '../components/SocialProof';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingElements } from '../components/FloatingElements';
import { ClassifiedProject } from '../components/ClassifiedProject';
import { AsSeenIn } from '../components/AsSeenIn';
export const Home = () => {
  return <div className="relative" data-id="element-1561">
      <TopBar data-id="element-1562" />
      <Navigation data-id="element-1563" />

      <main data-id="element-1564">
        <Hero data-id="element-1565" />
        <Ticker data-id="element-1566" />
        <Mission data-id="element-1567" />
        <AsSeenIn data-id="element-1568" />
        <UseCases data-id="element-1569" />
        <WhatsInBox data-id="element-1570" />
        <Materials data-id="element-1571" />
        <Product data-id="element-1572" />
        <Guarantee data-id="element-1573" />
        <FAQ data-id="element-1574" />
        <ClassifiedProject data-id="element-1575" />
        <SocialProof data-id="element-1576" />
        <Contact data-id="element-1577" />
      </main>

      <Footer data-id="element-1578" />
      <FloatingElements data-id="element-1579" />
    </div>;
};